var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884e8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.429 0H2.57C1.151 0 0 1.151 0 2.571v12c0 1.42 1.151 2.572 2.571 2.572H21.43c1.42 0 2.571-1.151 2.571-2.572v-12C24 1.151 22.849 0 21.429 0zm.857 14.571c0 .474-.384.858-.857.858H2.57c-.473 0-.857-.384-.857-.858v-.502l3.429-3.428 2.822 2.822c.335.335.878.335 1.212 0l7.109-7.108 6 6v2.216zm0-4.64l-5.394-5.394c-.335-.335-.878-.335-1.212 0L8.57 11.645 5.75 8.823c-.335-.335-.877-.335-1.212 0l-2.823 2.822V2.571c0-.473.384-.857.857-.857H21.43c.473 0 .857.384.857.857v7.36z",
    transform: "translate(-628.000000, -3742.000000) translate(628.000000, 3742.000000) translate(4.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.714 3.429c-1.42 0-2.571 1.15-2.571 2.571 0 1.42 1.151 2.571 2.571 2.571 1.42 0 2.572-1.15 2.572-2.571 0-1.42-1.152-2.571-2.572-2.571zm0 3.428c-.473 0-.857-.384-.857-.857s.384-.857.857-.857c.474 0 .857.384.857.857s-.383.857-.857.857z",
    transform: "translate(-628.000000, -3742.000000) translate(628.000000, 3742.000000) translate(4.000000, 7.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.ad01e7b7.svg";
export { ForwardRef as ReactComponent };